import IItemOrderStatusViewModel from "interfaces/IItemOrderStatusViewModel";

const LocationTemplate = ({ hwrcSiteName, regionName }: IItemOrderStatusViewModel): any => (

  <>
    <span className="fw-bold">
      {hwrcSiteName}

    </span>
    <br />
    <span>{regionName}</span>
  </>
);
export default LocationTemplate;
